export default __webpack_public_path__ + "static/pytest-unittest-2f6ee5bb429abcb54c7b3512ed1ec486.png";